import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import HttpBackend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { supportedLanguages } from "./util/language"

// Since cookie banner and cookie modal are being rendered outside of "gastby page" scope, the existing i18n context is not visible for them
// That's why we introduce a separate context only for those components
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    defaultNS: "index",
    ns: ["index"],
    detection: {
      order: ["path"],
      lookupFromPathIndex: 0,
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/index.json",
    },
  })

export default i18n
